<div id="orders" class="page-layout carded fullwidth ">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">

            <div fxLayout="row" fxLayoutAlign="space-between center">

                <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                    <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'LOCATION_TRACKING' |
                        translate}}</span>
                </div>

                <div class="search-wrapper ml-sm-32">
                    <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon>search</mat-icon>
                        <input #filter [(ngModel)]="filterText" (keyup)="onSearchListen($event)" placeholder="Konteyner Adı"  [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option *ngFor="let item of autoComplateContainers" [value]="item.name" (click)="onAutoComplateClick(item)">
                              {{item.name}}
                            </mat-option>
                          </mat-autocomplete>
                    </div>
                </div>

            </div>
        </div>
        
        <!-- / HEADER -->
        <div class="content-card my-20" style="padding: 5px;">
            <div class="map-container">
                <div class="map-frame">
                    <div id="map">
                        <div mat-dialog-actions align="end">
                            <div style="position: relative; margin:10px;" fxLayout="column"
                                fxLayoutAlign="end end">
                                <div style="z-index: 99999;" fxLayout="column"
                                fxLayoutAlign="end end">
                                    <button matTooltip="{{'ADD_GARBAGE_CENTER'|translate}}" mat-raised-button
                                        style="margin-bottom: 10px;" (click)="onAddMasterLocationClick($event)">
                                        <mat-icon>outlined_flag</mat-icon>
                                    </button>
                                    <button matTooltip="{{'CONTAINER_OPERATIONS'|translate}}" mat-raised-button
                                        style="margin-bottom: 10px;" [matMenuTriggerFor]="menu">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="onAddLocationClick($event)">
                                            <mat-icon>pin_drop</mat-icon>
                                            <span>{{'SET_LOCATION'|translate}}</span>
                                        </button>
                                        <button mat-menu-item (click)="onAddContainerClick($event)">
                                            <mat-icon>add</mat-icon>
                                            <span>{{'ADD_CONTAINER'|translate}}</span>
                                        </button>
                                    </mat-menu>
                                    <button  style="margin-bottom: 10px;" matTooltip="{{'ENVANTER'|translate}}" mat-raised-button
                                        (click)="onAddEnvanterClick($event)">
                                        <mat-icon>business_center</mat-icon>
                                    </button>
    
                                    <button matTooltip="{{'TURN_OFF_MARKUP'|translate}}"
                                        *ngIf="markerOpen || markerMasterOpen || envanterMarkerOpen" mat-raised-button
                                        (click)="onCancelLocationClick($event)">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>